import React, { useContext } from 'react'

import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'

import Tooltip from '@components/shared/Tooltip'
import { TitleContext } from '@providers/TitleProvider'
import { useSession } from '@stores/globalData/globalData.store'
import { isLearnPcPreview } from '@utils/page-routes'

import DetailElement from './DetailElement'

const SellableArrangements: React.FC = () => {
  const { title } = useContext(TitleContext)
  const { t } = useTranslation()
  const session = useSession()
  const { pathname } = useLocation()

  if (!session.isDefaultCommunity() || isLearnPcPreview(pathname)) return null

  return (
    <DetailElement
      label="sellableArrangements"
      value={
        <span className="inline-flex flex-row items-center">
          {title.product?.sellable_arrangements ? t('content.allowed') : t('content.notAllowed')}
          <Tooltip
            arrow
            content={t('hint.purchaseScore.sellableArrangements')}
            placement="bottom"
            maxWidth={210}>
            <i className="nf-icon nf-help-sign ml-1 text-gray-icons dark:text-gray-icons-dm" />
          </Tooltip>
        </span>
      }
    />
  )
}

export default SellableArrangements
